import React, {PropTypes, Component} from 'react';
import utils from '../../utils/utils';
import SingleNavigationItem from '../partial/SingleNavigationItem/SingleNavigationItem';
import SearchController from '../../containers/Search/Search';
import {Link} from 'react-router';

const s = require('./navigation.scss');

class Navigation extends Component {

  handleNavigationClick(biParams) {
    utils.reportBi('334', `${biParams}&location=side bar`);
    this.props.search('');
    this.props.datePickerDatesRange();
  }

  render() {
    const {isActive, activeExperiments, locale} = this.props;
    return (
      <aside className={s.aside}>
        <SearchController/>
        <nav>
          <label>Filter By</label>
          <ul data-hook="top-navigation-links">
            <li>
              <SingleNavigationItem
                path="/" active={isActive('/')} biParams="button_name=all updates" label={locale[`wix-general_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li>
              <SingleNavigationItem
                path="/new-features" active={isActive('/new-features')} biParams="button_name=new features" label={locale[`new-features_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li>
              <SingleNavigationItem
                path="/feature-updates" active={isActive('/feature-updates')} biParams="button_name=feature updates" label={locale[`feature-updates_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li>
              <SingleNavigationItem
                path="/bug-fixes" active={isActive('/bug-fixes')} biParams="button_name=bug fixes" label={locale[`bug-fixes_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
          </ul>
          <label>{locale.navigation_wix_products}</label>
          <ul data-hook="navigation-links">
            <li>
              <SingleNavigationItem
                path="/wix-home" active={isActive('/wix-home')} biParams="button_name=wix home" label={locale[`wix-home_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li>
              <SingleNavigationItem
                path="/wix-editor" active={isActive('/wix-editor')} biParams="button_name=wix editor" label={locale[`wix-editor_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li>
              <SingleNavigationItem
                path="/wix-adi" active={isActive('/wix-adi')} biParams="button_name=wix adi" label={locale[`wix-adi_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li>
              <SingleNavigationItem
                path="/wix-stores" active={isActive('/wix-stores')} biParams="button_name=wix stores" label={locale[`wix-stores_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li>
              <SingleNavigationItem
                path="/wix-mobile-app" active={isActive('/wix-mobile-app')} biParams="button_name=wix mobile app" label={locale[`wix-mobile-app_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li>
              <SingleNavigationItem
                path="/wix-shoutout" active={isActive('/wix-shoutout')} biParams="button_name=wix shoutout" label={locale[`wix-shoutout_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li className={`${activeExperiments.indexOf('wixMusic') !== -1 ? '' : s.hide}`}>
              <SingleNavigationItem
                path="/wix-music" active={isActive('/wix-music')} biParams="button_name=wix music" label={locale[`wix-music_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li className={`${activeExperiments.indexOf('wixRestaurants') !== -1 ? '' : s.hide}`}>
              <SingleNavigationItem
                path="/wix-restaurants" active={isActive('/wix-restaurants')} biParams="button_name=wix restaurants" label={locale[`wix-restaurants_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
            <li className={`${activeExperiments.indexOf('wixPhotography') !== -1 ? '' : s.hide}`}>
              <SingleNavigationItem
                path="/wix-photography" active={isActive('/wix-photography')} biParams="button_name=wix photography" label={locale[`wix-photography_page_name`]}
                onClick={biParams => this.handleNavigationClick(biParams)}
                />
            </li>
          </ul>
          <Link to="/subscribe" className={`${s.subscribeBtn} ${activeExperiments.indexOf('subscribe') !== -1 ? '' : s.hide}`}>{locale.navigation_subscribe}</Link>
        </nav>
      </aside>
    );
  }
}

Navigation.propTypes = {
  isActive: PropTypes.func.isRequired,
  fetchPosts: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  datePickerDatesRange: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired,
  activeExperiments: PropTypes.array
};

export default Navigation;



// WEBPACK FOOTER //
// ./components/Navigation/Navigation.js